export const getUsuariosAuditor = (state) => state.usuariosAuditor.lista
export const getIsCarregandoListaUsuariosAuditor =
  (state) => state.usuariosAuditor.isCarregandoLista
export const getUsuarioAuditorSelecionado = (state) => state.usuariosAuditor.selecionado
export const getIsCarregandoUsuarioAuditor = (state) => state.usuariosAuditor.isCarregandoUsuario
